import MarqueeMessage from './MarqueeMessage'

export default MarqueeMessage
